import { useState } from 'react';
import type { Page } from '../../schemas/validation';
import type { PreviewData, PreviewState } from './types';

export const usePreviewState = (): PreviewState => {
  const [previewData, setPreviewData] = useState<PreviewData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [sitePages, setSitePages] = useState<Page[]>([]);

  return {
    previewData,
    setPreviewData,
    isLoading,
    setIsLoading,
    error,
    setError,
    sitePages,
    setSitePages,
  };
};
